import Select, { type SelectOption } from "components/ui/Select";

type SearchableFormSelectProps = {
  value: number | string | undefined | null;
  onChange: (next: number | string | null) => void;
  options: SelectOption[];
  isArabic: boolean;
  /** Coerce selection to number (e.g. grade_id); empty selection becomes `null` or `emptyNumber` */
  numeric?: boolean;
  emptyNumber?: number | null;
  /** When false, no “clear” row (e.g. gender). Default true. */
  allowEmpty?: boolean;
  placeholder?: string;
  disabled?: boolean;
  id?: string;
};

/**
 * Searchable single-select for forms (modals, CRUD panels).
 * Thin wrapper around the unified Select component.
 */
export default function SearchableFormSelect({
  value,
  onChange,
  options,
  isArabic,
  numeric,
  emptyNumber = null,
  allowEmpty = true,
  placeholder,
  disabled,
  id,
}: SearchableFormSelectProps) {
  return (
    <Select
      id={id}
      value={value}
      onChange={(next) => {
        if (numeric) {
          if (next === null || next === "") {
            onChange(emptyNumber ?? null);
          } else {
            onChange(Number(next));
          }
        } else {
          onChange(next as string | number | null);
        }
      }}
      options={options}
      isArabic={isArabic}
      searchable
      numeric={numeric}
      emptyValue={numeric ? emptyNumber ?? null : null}
      allowEmpty={allowEmpty}
      clearable={allowEmpty}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
}
